<template>
  <div>
    <UsersForm @done="done"></UsersForm>
  </div>
</template>

<script>
import UsersForm from 'CORE/components/users/form'

export default {
    name: 'UsersAdministrationNewView',
    components: {
        UsersForm,
    },
    methods: {
        done() {
            this.$router.push({ name: 'usersList' })
        },
    },
}
</script>
